import React from 'react'

import data from '../../../../data/water-treatment-plants'
import { WaterTreatmentPlantIcon } from '../../../../icons'

import LayerContent from '../../LayerContent'

import Description from './Description'
import Project from '../../Project'

const WaterTreatmentPlants = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) =>
        data.entries.map(resource => (
          <Project
            data={resource}
            setActiveProject={setActiveProject}
            active={active}
            key={resource.id}
            name="treatment"
            icon={() => <WaterTreatmentPlantIcon />}
          />
        ))
      }
    </LayerContent>
  )
}

export { Description as WaterTreatmentPlantDescription }
export default WaterTreatmentPlants
